
import React from "react";
import { useSelector } from "react-redux";
import { get } from 'lodash';
import NoMatch from "./NoMatch";
import { getHomepageLink } from "../../helpers/navigation";

const Forbidden = ({ status }) => {
    const { roleId = false } = useSelector((state) => get(state, 'storage.data', {}));
    const link = getHomepageLink(roleId);

    if (status === 403) {
        return (
            <NoMatch
                link={false}
                title="Forbidden"
                text="You do not have permissions to view this page."
            />
        )
    }

    return (
        <NoMatch link={link} />
    )
}

export default Forbidden;